import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "space-y-4"
};
const _hoisted_2 = {
  class: "grid grid-cols-1 gap-3 md:grid-cols-4"
};
const _hoisted_3 = {
  class: "rounded-lg bg-slate-50 p-3"
};
const _hoisted_4 = {
  class: "mt-1 text-sm font-medium text-slate-900"
};
const _hoisted_5 = {
  class: "rounded-lg bg-slate-50 p-3"
};
const _hoisted_6 = {
  class: "mt-1 text-sm font-medium text-slate-900"
};
const _hoisted_7 = {
  class: "rounded-lg bg-slate-50 p-3"
};
const _hoisted_8 = {
  class: "mt-1 text-sm font-medium text-slate-900"
};
const _hoisted_9 = {
  class: "rounded-lg bg-slate-50 p-3"
};
const _hoisted_10 = {
  class: "mt-1 text-sm font-medium text-slate-900"
};
const _hoisted_11 = {
  key: 0,
  class: "rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-700"
};
const _hoisted_12 = {
  key: 0,
  class: "grid gap-3 md:grid-cols-2"
};
const _hoisted_13 = {
  class: "text-xs text-slate-500"
};
const _hoisted_14 = {
  class: "mt-1 whitespace-pre-wrap break-all text-sm text-slate-900"
};
const _hoisted_15 = {
  key: 1,
  class: "rounded-lg border border-dashed border-slate-200 py-8 text-center text-sm text-slate-500"
};
const _hoisted_16 = {
  key: 0,
  class: "space-y-3"
};
const _hoisted_17 = {
  class: "material-file-main"
};
const _hoisted_18 = ["title"];
const _hoisted_19 = {
  class: "material-file-meta"
};
const _hoisted_20 = {
  class: "material-file-actions"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  key: 1,
  class: "rounded-lg border border-dashed border-slate-200 py-8 text-center text-sm text-slate-500"
};
import axios from 'axios';
import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getCustomerMaterialDetailById } from '@/api/customer';
import { useUserStore } from '@/stores/user';
import FileAttachment from './FileAttachment.vue';
import { normalizeCustomerMaterialFile, withBlobPreview } from '@/utils/filePreview';
export default {
  __name: 'OrderMaterialDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userMaterialId: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const materialDetail = ref(null);
    const dialogVisible = computed({
      get: () => props.visible,
      set: value => emit('update:visible', value)
    });
    const materialFiles = computed(() => materialDetail.value?.files || []);
    const formEntries = computed(() => {
      const parsed = parseJsonSafely(materialDetail.value?.formData, {});
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return [];
      }
      return Object.entries(parsed).map(([key, value]) => ({
        key,
        value: typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value ?? '-')
      }));
    });
    watch(() => [props.visible, props.userMaterialId], async ([visible, userMaterialId]) => {
      if (!visible || !userMaterialId) {
        return;
      }
      loading.value = true;
      try {
        materialDetail.value = await getCustomerMaterialDetailById(userMaterialId);
      } catch (error) {
        ElMessage.error(error?.message || '获取资料详情失败');
      } finally {
        loading.value = false;
      }
    }, {
      immediate: true
    });
    const parseJsonSafely = (value, fallback) => {
      if (value === null || value === undefined || value === '') {
        return fallback;
      }
      if (typeof value === 'object') {
        return value;
      }
      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    };
    const getMaterialDownloadUrl = file => {
      return toPreviewFile(file).downloadSource;
    };
    const toPreviewFile = file => withBlobPreview(normalizeCustomerMaterialFile(file), 'customer-material');
    const getAuthHeaders = () => {
      const userStore = useUserStore();
      const headers = {};
      if (userStore.accessToken) {
        headers.Authorization = `${userStore.tokenType} ${userStore.accessToken}`;
      }
      let deviceId = localStorage.getItem('deviceId');
      if (!deviceId) {
        deviceId = `WEB-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        localStorage.setItem('deviceId', deviceId);
      }
      headers['X-Device-Id'] = deviceId;
      headers['X-Client-Type'] = 'web';
      return headers;
    };
    const downloadBlob = (blob, filename) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || 'download';
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    };
    const loadPreviewFile = async (file, options = {}) => {
      const source = options.purpose === 'download' ? file.downloadSource || file.downloadUrl : file.previewSource || file.url;
      const response = await axios.get(source, {
        responseType: 'blob',
        headers: getAuthHeaders()
      });
      return {
        data: response.data,
        contentType: response?.headers?.['content-type'] || response.data?.type || file.contentType
      };
    };
    const handleDownloadMaterialFile = async file => {
      try {
        const response = await axios.get(getMaterialDownloadUrl(file), {
          responseType: 'blob',
          headers: getAuthHeaders()
        });
        downloadBlob(response.data, file?.originalName);
      } catch (error) {
        ElMessage.error(error?.message || '下载失败，请稍后重试');
      }
    };
    const handleClose = () => {
      emit('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: "资料详情",
        width: "920px",
        "destroy-on-close": "",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", {
          class: "flex justify-end"
        }, [_createElementVNode("button", {
          class: "px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200",
          onClick: handleClose
        }, "关闭")])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [materialDetail.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "资料名称", -1)), _createElementVNode("div", _hoisted_4, _toDisplayString(materialDetail.value.name || '-'), 1)]), _createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "资料类型", -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(materialDetail.value.definitionName || materialDetail.value.definitionCode || '-'), 1)]), _createElementVNode("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "客户可见性", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(materialDetail.value.visibleToCustomer ? '对客户可见' : '对客户隐藏'), 1)]), _createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "最后更新时间", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$formatDateTime(materialDetail.value.updateTime || materialDetail.value.lastUploadTime || materialDetail.value.createTime)), 1)])]), materialDetail.value.expireDate ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 有效期截止：" + _toDisplayString(_ctx.$formatDateTime(materialDetail.value.expireDate)), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "mb-2 text-sm font-medium text-slate-700"
        }, "表单内容", -1)), formEntries.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formEntries.value, entry => {
          return _openBlock(), _createElementBlock("div", {
            key: entry.key,
            class: "rounded-lg border border-slate-200 p-3"
          }, [_createElementVNode("div", _hoisted_13, _toDisplayString(entry.key), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(entry.value), 1)]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_15, " 暂无表单内容 "))]), _createElementVNode("div", null, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "mb-2 text-sm font-medium text-slate-700"
        }, "文件列表", -1)), materialFiles.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialFiles.value, file => {
          return _openBlock(), _createElementBlock("div", {
            key: file.id,
            class: "material-file-row"
          }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
            class: "material-file-name",
            title: file.originalName
          }, _toDisplayString(file.originalName || '附件'), 9, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, "字段：" + _toDisplayString(file.fieldName || file.fieldCode || '-'), 1), _createElementVNode("span", null, "版本：" + _toDisplayString(file.version || '-'), 1), _createElementVNode("span", null, "上传时间：" + _toDisplayString(_ctx.$formatDateTime(file.uploadTime)), 1)])]), _createElementVNode("div", _hoisted_20, [_createVNode(FileAttachment, {
            variant: "button",
            files: toPreviewFile(file),
            loader: loadPreviewFile
          }, null, 8, ["files"]), _createElementVNode("button", {
            class: "table-action-button is-primary",
            onClick: $event => handleDownloadMaterialFile(file)
          }, "下载", 8, _hoisted_21)])]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_22, " 暂无文件 "))])], 64)) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};